module.exports = __webpack_public_path__ + "img/American-Credit-SBA-Loans.560a412.jpeg";